import { Component, ChangeDetectionStrategy, input, output, inject } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Upload } from '@xmedical/core';
import { FileUploaderService } from '../../services/file-uploader.service';
import { FileUpdaterComponent, FileUpdaterDialogData } from '../file-updater/file-updater.component';
import { DisplayMode } from '../../models/display-mode.type';

@Component({
  selector: 'xmed-file-editor',
  exportAs: 'libFileEditor',
  standalone: true,
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileEditorComponent {
  private readonly fileUploadService = inject(FileUploaderService);
  private readonly bottomSheet = inject(MatBottomSheet);
  private readonly dialog = inject(MatDialog);

  upload = input.required<Upload>();
  displayMode = input<DisplayMode>('bottomsheet');

  processing = output<boolean>();
  deleted = output<number>();
  updated = output<Upload>();

  private bottomSheetRef: MatBottomSheetRef<FileUpdaterComponent> | null = null;
  private dialogRef: MatDialogRef<FileUpdaterComponent> | null = null;

  editAttachment(): void {
    const data: FileUpdaterDialogData = { upload: this.upload() };

    if (this.displayMode() === 'dialog') {
      this.dialogRef = this.dialog.open(FileUpdaterComponent, {
        disableClose: true,
        width: '600px',
        data
      });
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.updated.emit(result);
        }
      });
    } else {
      this.bottomSheetRef = this.bottomSheet.open(FileUpdaterComponent, {
        disableClose: true,
        data
      });
      this.bottomSheetRef.afterDismissed().subscribe((result) => {
        if (result) {
          this.updated.emit(result);
        }
      });
    }
  }

  deleteAttachment(): void {
    this.processing.emit(true);
    const uploadId = this.upload().id;
    this.fileUploadService.deleteUpload(uploadId).subscribe({
      next: (success) => {
        this.processing.emit(false);
        if (success) {
          this.deleted.emit(uploadId);
        }
      },
      error: (err) => {
        this.processing.emit(false);
        console.error('Failed to delete attachment:', err);
      }
    });
  }
}
